import { render, staticRenderFns } from "./RekapBencana.vue?vue&type=template&id=7181f980&scoped=true"
import script from "./RekapBencana.vue?vue&type=script&lang=js"
export * from "./RekapBencana.vue?vue&type=script&lang=js"
import style0 from "./RekapBencana.vue?vue&type=style&index=0&id=7181f980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181f980",
  null
  
)

export default component.exports